import { Input } from 'reactstrap';
import moment from 'moment';
import { formatTime12Hour } from '@s20/common/util/date';

export const HourlyIncrements = {
    5: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
    10: ['00', '10', '20', '30', '40', '50'],
    15: ['00', '15', '30', '45'],
    30: ['00', '30'],
};

export const HoursValues12Hour = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

// RLC: Lookup an array of printed time values based on what increment is provided.
const getIncrementsOptions = (incrementValue) => {
    let increments = null;
    const options = [];
    switch (incrementValue) {
        case 0.083:
            increments = HourlyIncrements['5'];
            break;
        case 0.167:
            increments = HourlyIncrements['10'];
            break;
        case 0.25:
            increments = HourlyIncrements['15'];
            break;
        case 0.5:
            increments = HourlyIncrements['30'];
            break;
        default:
            increments = null;
            break;
    }

    if (increments !== null) {
        // RLC: using the increments arrays, get options values based on the antemeridian
        HoursValues12Hour.map((h) => increments.map((x) => options.push(`${h}:${x} AM`)));
        HoursValues12Hour.map((h) => increments.map((x) => options.push(`${h}:${x} PM`)));
        options.sort(
            (a, b) => moment(a, ['h:mm A']) - moment(b, ['h:mm A']),
        );
        return options;
    }
    return [];
};

/**
 * Time picker, dropdown style.  Originally implemented to constrain input on timesheet entry.
 *
 * {value}: Saves value in 24 hour format, but constrains user input display to 12 hour.
 *
 * Added: RLC 5/3/21
 *
 * */
export const TimeEntry = (props) => {
    const {
        required, disabled, name, value, increment,
    } = props;

    const disableEmptyOption = !!(required || disabled);

    const displayValue = formatTime12Hour(value);
    const options = getIncrementsOptions(increment);
    const showCurrentValueOption = !!displayValue && !options.includes(displayValue);

    /// /TODO: Perhaps display the old html5 input control if increments are not provided or not constrained.
    return (
        <Input
            required={required}
            disabled={disabled}
            name={name}
            type="select"
            className="time-input-entry form-control"
            value={displayValue}
            onChange={props.onChange}
        >
            <option
                value=""
                disabled={disableEmptyOption}
            >--</option>
            {showCurrentValueOption && (
                <option value={displayValue}>{displayValue}</option>
            )}
            {options.map((o) => (
                <option
                    key={o}
                    value={o}
                >{`${o}`}</option>
            ))}
        </Input>
    );
};

export default TimeEntry;